import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { BsGripVertical } from "react-icons/bs";
import { FaEdit, FaTrash } from "react-icons/fa";


export default function MilestoneCard({ point, index, totalPoints, onEdit, onDelete }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: point.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const getLabel = () => {
    if (index === 0) return "S";
    if (index === totalPoints - 1) return "E";
    return index;
  };

  return (
    <div ref={setNodeRef} style={style} className="milestone-card">
      <div className="milestone-card__body">
        <div className="milestone-card__left">
          <div
            className="drag-handle"
            {...attributes}
            {...listeners}
          >
            <BsGripVertical />
          </div>

          <div className="milestone-card__info">
            <button type="button" className="btn btn-primary milestone-index">
              {getLabel()}
            </button>

            <div className="milestone-card__text">
              <h6 className="milestone-card__name">{point.name}</h6>
              {point.location && (
                <p className="milestone-card__location">{point.location}</p>
              )}
            </div>
          </div>
        </div>

        {/* {point.preview && (
          <img
            src={point.preview}
            alt={point.name}
            className="milestone-card__image"
          />
        )} */}
      </div>

      <div className="milestone-card__footer">

        <div className="milestone-card__actions">
          <button type="button" className="btn-icon" onClick={() => onEdit(point)}>
            <FaEdit />
          </button>
          <button type="button" className="btn-icon btn-icon--danger" onClick={() => onDelete(point.id)}>
            <FaTrash />
          </button>
        </div>
      </div>
    </div>
  );
}